<template>
  <div class="flex flex-col mb-3">
    <div style="height: 100%" class="mt-20" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>

    <div v-else>
      <div class="w-full flex flex-col items-center" v-if="comments.length === 0">
        <icon icon-name="empty_comments" size="xl" style="width: 450" />
      </div>

      <div class="h-full w-full" v-else>
        <scroll-container height="450px" style="width: 100%; overflow-x: hidden">
          <div
            v-for="item in comments"
            :key="item.id || item.comment || item.date"
            class="w-full flex flex-col mb-1 p-2"
          >
            <div :class="[isMe(item) ? 'pl-0' : 'pl-7']">
              <div class="w-full flex">
                <div class="flex">
                  <img
                    class="mr-1"
                    :src="item.sender.photo"
                    v-if="item.sender.photo"
                    alt="user photo"
                    style="height: 40px; width: 40px; border-radius: 5px"
                  />
                  <div
                    style="height: 40px; width: 40px; border-radius: 5px"
                    class="text-blueCrayola mr-1 flex justify-center border text-center font-semibold pt-1"
                    v-else
                  >
                    {{ $getInitials(`${item.sender.fname} ${item.sender.lname}`) }}
                  </div>
                </div>
                <div
                  class="flex w-full flex-col whitespace-nowrap font-semibold text-sm leading-5"
                >
                  <div class="flex w-full ml-2">
                    <div class="flex flex-grow">
                      <span class="text-darkPurple capitalize">
                        {{ `${item.sender.fname} ${item.sender.lname} `}}
                      </span>
                    </div>
                  </div>
                  <span class="flex text-xs ml-2 text-blueCrayola font-black">
                    {{ item.sender.designation }}
                  </span>
                </div>
              </div>

              <div class="my-2 w-full flex flex-col gap-1">
                <p class="flex flex-grow break-all font-normal text-xs neutral-black bg-hex p-3 rounded-lg"
                  :class="[isMe(item) ? 'bg-hex' : 'bg-accent-hex']"
                >
                    {{ item.comment }}
                </p>
                <div class="w-full flex justify-between items-center">
                  <div
                    class="text-xs font-semibold flex justify-center items-center text-romanSilver uppercse gap-2"
                  >
                    <span>{{ getLastUploadedTime(item.date) }}</span>
                    <span class="display-inline"></span>
                    <span>{{ $DATEFORMAT(new Date(item.date), "MMMM dd, yyyy") }}</span>
                  </div>
                  <!-- <div class="flex justify-end">
                    <icon icon-name="icon-trash" size="xs" />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </scroll-container>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollContainer from "./ScrollContainer";

export default {
  name: "CommentsBox",
  components: { ScrollContainer },
  props: {
    comments: { type: Array, default: () => [] },
    loading: { type: Boolean, default: true },
    // Current logged-in user's id 
    senderId: { type: String, default: "" },
  },
  methods: {
    isMe(item) {
      return item?.sender?.senderId === this.senderId;
    },
    markAsRead(commentId) {
      this.$emit("markRead", commentId);
    },
    getLastUploadedTime(time) {
      const date = new Date(time);
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      return `${hours}:${minutes}${ampm}`;
    },
  },
};
</script>

<style scoped>
.neutral-black {
  color: #212121;
}
.bg-hex {
  background: #4142450f;
}
.bg-accent-hex {
  background: #f7b53814;
}
.display-inline {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #878e99;
  border-radius: 9999px;
}
</style>